import type { DialogProps } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle, Modal, Slide } from "@mui/material";

import { useWindowSize } from "utils/hooks";

import { FullScreenBox } from "../MUIUnifiedModal/MUIUnifiedModal";

type MUIDialogProps = DialogProps & {
  children?: React.ReactNode;
  dialogActions?: React.ReactNode;
  dialogContent?: React.ReactNode;
  dialogTitle: React.ReactNode;
};

export const MUIDialog: React.FC<MUIDialogProps> = ({
  children,
  dialogActions,
  dialogContent,
  dialogTitle,
  open,
  onClose,
  ...props
}) => {
  const { isSmallScreen } = useWindowSize();

  const getDialogContent = () => {
    if (children) {
      return <>{children}</>;
    }
    return (
      <>
        {dialogContent && (
          <DialogContent style={{ textAlign: "center", whiteSpace: "pre-wrap" }}>{dialogContent}</DialogContent>
        )}
        {dialogActions && <DialogActions>{dialogActions}</DialogActions>}
      </>
    );
  };

  if (isSmallScreen) {
    return (
      <Modal
        open={open ?? false}
        onClose={onClose}
        slotProps={{
          backdrop: {
            sx: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
          },
        }}
      >
        <Slide in={open} direction="up" mountOnEnter unmountOnExit timeout={400}>
          <FullScreenBox sx={{ height: "95vh" }}>
            <DialogTitle display="flex" alignItems="center" gap={2}>
              {dialogTitle}
            </DialogTitle>
            {getDialogContent()}
          </FullScreenBox>
        </Slide>
      </Modal>
    );
  }

  return (
    <Dialog open={open ?? false} onClose={onClose} {...props}>
      <DialogTitle display="flex" alignItems="center" gap={2}>
        {dialogTitle}
      </DialogTitle>
      {getDialogContent()}
    </Dialog>
  );
};
